import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, Utensils, Heart } from 'lucide-react';

export default function ImpactHighlight() {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="max-w-4xl mx-auto my-12 p-8 bg-white rounded-3xl border-2 border-gh-orange/20 shadow-xl text-center"
    >
      <div className="flex justify-center gap-6 mb-6 text-gh-orange">
        <GraduationCap size={32} />
        <Utensils size={32} />
        <Heart size={32} />
      </div>
      
      <h3 className="text-2xl md:text-3xl font-bold text-gh-blue leading-relaxed">
        <span className="text-gh-orange text-4xl font-black block md:inline mb-2 md:mb-0">
          $50 per month
        </span> 
        {" "}can provide a child with education, food, and basic needs.
      </h3>
      
      <p className="mt-4 text-gray-500 font-medium italic">
        "Small acts of kindness, when multiplied by many, can transform the world."
      </p>
    </motion.div>
  );
}